<!-- Choose a username -->
<div *ngIf="currentStep === 'username'" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
    <div class="flex items-center flex-col gap-6 bg-white rounded-[15px] p-4 sm:p-5 md:p-6 lg:p-[30px] w-full max-w-[528px] text-left">
        <div class="w-full">
            <h2 class="text-lg md:text-xl lg:text-2xl text-black font-bold mb-1.5">Choose a username</h2>
            <p class="text-base font-medium text-secondary-text-black">You can update this later</p>
        </div>
        <div class="w-full">
            <div class="relative border border-secondary-button-black rounded-lg py-4 px-4.5 mb-5">
                <input 
                    type="text" 
                    placeholder="@username"
                    maxlength="25"
                    [(ngModel)]="usernameForm.username"
                    (ngModelChange)="onUsernameInput($event)"
                    (blur)="usernameForm.touched = true"
                    appUsernameValidator
                    #username="ngModel"
                    class="placeholder:text-[#00000059] text-base !leading-4 font-normal text-black border-0 outline-0 p-0 pr-32 w-full truncate" />
                <button
                    (click)="saveUsername()"
                    [disabled]="!canContinueUsername(username.invalid)"
                    [class.opacity-50]="!canContinueUsername(username.invalid)"
                    [class.cursor-not-allowed]="!canContinueUsername(username.invalid)"
                    class="absolute right-[7px] top-2 font-syne text-white text-sm font-semibold bg-black rounded-[7px] py-2.5 px-6 cursor-pointer hover:bg-secondary-button-black">
                    {{ isLoading ? 'Processing...' : 'Continue' }}
                </button>
            </div>
            <!-- Validation errors -->
            <div *ngIf="(usernameForm.touched || usernameForm.username) && (username.invalid || usernameForm.isTaken || usernameForm.isValidating)" class="mb-4">
                <div *ngIf="usernameForm.isValidating" class="text-blue-500 text-xs font-medium">
                    Checking availability...
                </div>
                <div *ngIf="!usernameForm.isValidating && usernameForm.isTaken && !username.invalid" class="text-red-500 text-xs font-medium">
                    This username is already taken. Please choose another one.
                </div>
                <div *ngIf="username.errors?.['usernameLength']" class="text-red-500 text-xs font-medium">
                    Username must be between 3 and 25 characters
                </div>
                <div *ngIf="username.errors?.['usernamePattern']" class="text-red-500 text-xs font-medium">
                    Username can only contain alphanumeric characters and underscores
                </div>
                <div *ngIf="username.errors?.['noAlphaChar']" class="text-red-500 text-xs font-medium">
                    Username must contain at least one alphabet character
                </div>
            </div>
            <div>
                <label class="flex items-start gap-3 cursor-pointer select-none">
                    <input type="checkbox" class="peer hidden" [(ngModel)]="agreeToTerms" />
                    <span class="flex h-5 w-5 items-center justify-center rounded-md border border-gray-300 peer-checked:border-black peer-checked:bg-black transition">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 12 9" fill="none">
                            <path d="M0.75 5.86388C0.75 5.86388 1.77273 5.86388 3.13636 8.25024C3.13636 8.25024 6.92645 2.00024 10.2955 0.750244" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span class="w-[calc(100%-35px)] text-sm text-secondary-text-black">
                        By trading, you agree to the Terms of use and attest you are not a U.S. person,
                        are not located in the U.S. and are not the resident of or located in a restricted jurisdiction.
                    </span>
                </label>
            </div>
        </div>
    </div>
</div>

<!-- What's your email? -->
<div *ngIf="currentStep === 'email'" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
    <div
        class="flex items-center flex-col gap-6 bg-white rounded-[15px] p-4 sm:p-5 md:p-6 lg:p-[30px] w-[528px] text-left">
        <div class="w-full">
            <h2 class="text-lg md:text-xl lg:text-2xl text-black font-bold mb-1.5">What's your email?</h2>
            <p class="text-base font-medium text-secondary-text-black">Enter email for market & trading alerts</p>
        </div>
        <div class="w-full">
            <div class="relative border border-secondary-button-black rounded-lg py-4 px-4.5 mb-3">
                <input
                    type="email"
                    placeholder="Email address"
                    [(ngModel)]="emailForm.email"
                    (blur)="emailForm.touched = true"
                    appEmailValidator
                    #email="ngModel"
                    class="placeholder:text-[#00000059] text-base !leading-4 font-normal text-black border-0 outline-0 p-0 w-full" />
                <button
                    (click)="saveEmail(email)"
                    [disabled]="email.invalid || isLoading"
                    [class.opacity-50]="email.invalid || isLoading"
                    [class.cursor-not-allowed]="email.invalid || isLoading"
                    class="absolute right-[7px] top-2 font-syne text-white text-sm font-semibold bg-black rounded-[7px] py-2.5 px-6 cursor-pointer">
                    {{ isLoading ? 'Processing...' : 'Continue' }}
                </button>
            </div>
            <div *ngIf="emailForm.email && email.invalid" class="mb-3">
                <div class="text-red-500 text-xs font-medium">
                    {{ getEmailValidationMessage(email.errors) }}
                </div>
            </div>
            <div class="text-center">
                <button
                    type="button"
                    (click)="skipEmail()"
                    class="text-secondary-text-black text-sm underline hover:text-black duration-200 ease-in-out cursor-pointer">
                    Do this later
                </button>
            </div>
        </div>
    </div>
</div>
<!-- Verification Link -->
<!-- <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
    <div class="flex items-center flex-col gap-6 bg-white rounded-[15px] p-4 sm:p-5 md:p-6 lg:p-[30px] w-[528px] text-left">
        <span class="w-[70px] h-[70px] p-4 mx-auto flex items-center justify-center rounded-full border border-light-black-200">
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                <path d="M3.00781 8.99951L13.3773 14.875C17.2002 17.041 18.8154 17.041 22.6383 14.875L33.0078 8.99951"
                    stroke="black" stroke-opacity="0.8" stroke-width="2" stroke-linejoin="round" />
                <path
                    d="M3.03147 20.2129C3.12952 24.8113 3.17856 27.1104 4.87525 28.8136C6.57193 30.5167 8.93331 30.576 13.6561 30.6946C16.5668 30.7678 19.4489 30.7678 22.3596 30.6946C27.0824 30.576 29.4437 30.5167 31.1405 28.8136C32.8371 27.1104 32.8862 24.8113 32.9841 20.2129C33.0158 18.7344 33.0158 17.2647 32.9841 15.7861C32.8862 11.1878 32.8371 8.88865 31.1405 7.1855C29.4437 5.48236 27.0824 5.42303 22.3596 5.30437C19.4489 5.23123 16.5668 5.23123 13.656 5.30435C8.93331 5.423 6.57193 5.48233 4.87524 7.18549C3.17854 8.88863 3.12952 11.1878 3.03145 15.7861C2.99992 17.2647 2.99994 18.7344 3.03147 20.2129Z"
                    stroke="black" stroke-opacity="0.8" stroke-width="2" stroke-linejoin="round" />
            </svg>
        </span>
        <h2 class="text-base text-secondary-text-black font-medium text-center">We are sending a verification link to 
            <a href="mailto:lokeshmurali44@gmail.com" class="block text-black">lokeshmurali44&#64;gmail.com</a>
        </h2>
        <h2 class="text-base text-secondary-text-black font-medium text-center">Didnâ€™t  get an email? <a href="mailto:lokeshmurali44@gmail.com" class="inline-blockblock text-black">Send again</a>
        </h2>
        <button (click)="closeEnableModal()" class="font-syne text-sm font-semibold text-white bg-black w-full rounded-[7px] hover:bg-secondary-button-black border border-black hover:text-black hover:border-black duration-200 ease-in-out cursor-pointer px-4 py-3">
            Close
        </button>
    </div>
</div> -->

<!-- Fund Your Account -->
<!-- <div *ngIf="currentStep === 'fund'" class="fixed inset-0 z-[100] flex items-center justify-center bg-black/50">
    <div
        class="flex items-center flex-col gap-6 bg-white rounded-[15px] p-4 sm:p-5 md:p-6 lg:p-[30px] w-[528px] text-center">
        <span class="w-[70px] h-[70px] p-4 mx-auto flex items-center justify-center rounded-xl bg-black">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                <path
                    d="M29.9318 13.9815C29.9318 10.4019 25.4858 7.5 20.0013 7.5C14.5168 7.5 10.0708 10.4019 10.0708 13.9815C10.0708 17.5612 12.7791 19.537 20.0013 19.537C27.2235 19.537 30.8346 21.3888 30.8346 26.0185C30.8346 30.6482 25.9845 32.5 20.0013 32.5C14.0182 32.5 9.16797 29.5982 9.16797 26.0185"
                    stroke="white" stroke-width="2" stroke-linecap="round" />
                <path d="M20.832 4.16675V7.01675M20.832 35.8334V32.9834" stroke="white" stroke-width="2"
                    stroke-linecap="round" />
            </svg>
        </span>
        <h2 class="text-lg md:text-xl lg:text-2xl text-black font-bold">Fund Your Account</h2>
        <div class="w-full flex flex-col gap-4 text-center">
            <button (click)="closeEnableModal()"
                class="font-syne text-sm font-semibold text-white bg-black w-full rounded-[7px] hover:bg-secondary-button-black border border-black hover:text-black hover:border-black duration-200 ease-in-out cursor-pointer px-4 py-3">
                Deposit Funds
            </button>
            <a href="#" class="text-sm font-normal underline text-secondary-text-black">Skip for now</a>
        </div>
    </div> -->
<!-- </div> -->
